var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoRejectedL(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "49px",
    viewBox: "0 0 56 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhotoRejectedL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.2201974,43.0296526 L32.7201034,1.68389014 C32.0634201,0.638950403 30.8843514,0 29.612512,0 C28.3406725,0 27.1616039,0.638839417 26.5049206,1.68389014 L0.521222863,43.0296526 C-0.154546686,44.1050027 -0.174558348,45.4462769 0.469053731,46.5396069 C1.11266581,47.6330478 2.31995899,48.3091787 3.62869858,48.3091787 L52.112606,48.3091787 C53.4213456,48.3091787 54.6286388,47.6329368 55.2722509,46.5396069 C55.915863,45.446166 55.895967,44.1050027 55.2201974,43.0296526 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhotoRejectedL"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FF0000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8593259,15.8305463 C30.3586468,15.8305463 31.6272761,16.625896 31.6272761,18.0356255 C31.6272761,22.3372675 31.0890732,28.5188767 31.0890732,32.8205188 C31.0890732,33.9411991 29.7819759,34.4109996 28.8593259,34.4109996 C27.6292807,34.4109996 26.5912267,33.9410898 26.5912267,32.8205188 C26.5912267,28.5188767 26.0531401,22.3372675 26.0531401,18.0356255 C26.0531401,16.625896 27.2831852,15.8305463 28.8593259,15.8305463 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8584357,41.843181 C27.2555041,41.843181 26.0531401,40.5401419 26.0531401,39.056113 C26.0531401,37.5358642 27.2553939,36.269045 28.8584357,36.269045 C30.3521117,36.269045 31.6272761,37.5358642 31.6272761,39.056113 C31.6272761,40.5401419 30.3521117,41.843181 28.8584357,41.843181 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoRejectedL);
export default __webpack_public_path__ + "static/media/icPhotoRejectedL.4a6e3643288680aadc9277aa2708b806.svg";
export { ForwardRef as ReactComponent };